<template>
  <main class="main">
    <Loader v-if="isLoading" />
    <Modal />
    <MintPage />
  </main>
</template>

<script setup>
import MintPage from '@/pages/Mint.vue'
import Loader from '@/components/Loader.vue'
import Modal from '@/components/Modal.vue'

import { computed } from 'vue'
import { useLayoutStore } from '@/store'

const layoutStore = useLayoutStore()

const isLoading = computed(() => layoutStore.isLoading)
</script>

<style lang="sass">
.main
  height: 100%
  display: flex
  align-items: center

</style>
